import PropTypes from 'prop-types';
import React from 'react';

import {
    IconArrowDown,
    IconArrowUp,
} from '$partials/icons/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const HeaderLink = ({
    index,
    isOpen,
    linkItem,
    setIsOpen
}) => {
    return (
        linkItem?.dropdown ? (
            <li className='group inline-block mr-10 last:mr-0 relative'>
                <button
                    className='flex gap-10 cursor-pointer items-center'
                    onClick={() => setIsOpen(isOpen !== index ? index : false)}
                    type='button'>
                    <span className='type-style-7'>
                        {linkItem?.title}
                    </span>

                    {isOpen === index ? <IconArrowUp colour='currentColor' /> : <IconArrowDown colour='currentColor' />}
                </button>
            </li>
        ) : (
            <li className='group inline-block mr-10 last:mr-0 relative'>
                <a
                    className='flex gap-10 cursor-pointer'
                    href={`/${linkItem?.collection?.__typename === 'BvaBusinessContactListingPage' ? 'contact' : linkItem?.collection?.slug}`}>
                    <span className='type-style-7'>
                        {linkItem?.title}
                    </span>
                </a>
            </li>
        )
    );};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    index: PropTypes.number,
    isOpen: PropTypes.any,
    linkItem: PropTypes.object,
    setIsOpen: PropTypes.func
};

HeaderLink.propTypes = propTypes;

export default HeaderLink;
